(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-draw-popup"]) return;
  try {
    
  (function(){
    var d=document.getElementById('asdraw'); if(!d||typeof d.showModal!=='function') return;
    var KEY='as_draw_v1', SKEY='as_draw_s';
    var posted=d.querySelector('[data-asdraw-posted]');
    if(posted){
      var okp=posted.getAttribute('data-asdraw-posted')==='ok';
      if(okp){ try{localStorage.setItem(KEY,JSON.stringify({s:'submitted',t:Date.now()}))}catch(e){} d.querySelector('[data-asdraw-step="form"]').hidden=true; d.querySelector('[data-asdraw-step="ok"]').hidden=false; }
      else { var pe=d.querySelector('[data-asdraw-err]'); if(pe) pe.textContent='No hemos podido guardar ese email. Revísalo e inténtalo de nuevo.'; }
      d.querySelectorAll('img').forEach(function(i){i.loading='eager';});
      d.addEventListener('click',function(e){ if(e.target===d||(e.target.closest&&e.target.closest('[data-asdraw-close]'))) d.close(); });
      d.showModal();
      try{document.dispatchEvent(new CustomEvent('alma:analytics',{detail:{name:okp?'gift_draw_email_submit':'gift_draw_email_error',marketing_consent:true}}))}catch(e){}
      try{window.Shopify&&Shopify.analytics&&Shopify.analytics.publish&&Shopify.analytics.publish(okp?'alma_gift_draw_email_submit':'alma_gift_draw_email_error',{marketing_consent:true})}catch(e){}
      try{history.replaceState(null,'',location.pathname+location.search.replace(/[?&]customer_posted=true/,'').replace(/^&/,'?'))}catch(e){}
      return;
    }
    var qs=new URLSearchParams(location.search), preview=qs.get('sorteo')==='preview';
    if(d.dataset.enabled!=='true'&&!preview) return;
    var page=d.dataset.page||''; if(!preview&&(page==='cart'||location.pathname.indexOf('/checkout')===0||location.pathname.indexOf('bases-sorteo')>-1)) return;
    // V2.5: páginas donde el pop-up NUNCA salta solo (la ficha de producto es donde aterriza el anuncio).
    var quiet=['product','page','policy','search','cart','captcha','password'].indexOf(page)>-1||page.indexOf('customers')===0||location.pathname.indexOf('/policies/')===0;
    var ls=function(){try{return JSON.parse(localStorage.getItem(KEY)||'{}')}catch(e){return {}}};
    var save=function(o){try{localStorage.setItem(KEY,JSON.stringify(o))}catch(e){}};
    var track=function(n,data){data=data||{};data.page_type=page;
      try{window.Shopify&&Shopify.analytics&&Shopify.analytics.publish&&Shopify.analytics.publish('alma_'+n,data)}catch(e){}
      try{(window.dataLayer=window.dataLayer||[]).push(Object.assign({event:'alma_'+n},data))}catch(e){}
      try{document.dispatchEvent(new CustomEvent('alma:analytics',{detail:Object.assign({name:n},data)}))}catch(e){}};
    var st=ls(), days=Number(d.dataset.days)||7;
    if(!preview){ if(st.s==='submitted') return; if(st.s==='dismissed'&&st.t&&(Date.now()-st.t)<days*864e5) return; }
    var ss={}; try{ss=JSON.parse(sessionStorage.getItem(SKEY)||'{}')}catch(e){}
    if(!ss.t0) ss.t0=Date.now(); ss.pv=(ss.pv||0)+1; try{sessionStorage.setItem(SKEY,JSON.stringify(ss))}catch(e){}
    if(ss.shown&&!preview) return;
    var delay=(Number(d.dataset.delay)||30)*1000, need=(Number(d.dataset.scroll)||0)/100, shown=false, submitted=false, pt0=Date.now();
    var scrolled=function(){var el=document.querySelector('.page-wrapper'); var top=Math.max(window.scrollY||0, el?el.scrollTop:0); var h=Math.max(document.documentElement.scrollHeight, el?el.scrollHeight:0)-window.innerHeight; return h>0?top/h:0;};
    var open=function(reason){
      if(shown) return; if(document.querySelector('dialog[open]')) return;
      // nunca con el carrito abierto: la clienta está comprando
      var cd=document.querySelector('cart-drawer-component[open], .cart-drawer[open], dialog.cart-drawer__dialog[open]'); if(cd) return;
      // nunca por encima del banner de cookies: primero se contesta el consentimiento
      var ckb=document.getElementById('shopify-pc__banner'); if(ckb&&ckb.getBoundingClientRect().height>0) return;
      try{ var cpv=window.Shopify&&Shopify.customerPrivacy; if(cpv&&cpv.shouldShowBanner&&cpv.shouldShowBanner()&&cpv.getTrackingConsent()==='no_interaction') return; }catch(e){}
      shown=true; ss.shown=1; try{sessionStorage.setItem(SKEY,JSON.stringify(ss))}catch(e){}
      d.querySelectorAll('img').forEach(function(i){i.loading='eager';});
      d.showModal(); track('gift_draw_popup_impression',{trigger:reason,session_state:ss.pv>1?'multi_page':'first_page'});
    };
    var check=function(){ if(shown||quiet) return; var el=Date.now()-ss.t0; if(el>=delay&&ss.pv>=2&&(Date.now()-pt0)>=6000&&(need<=0||scrolled()>=need)) open(need<=0?'time_pageviews':'time_scroll_pageviews'); };
    if(preview){ try{fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_sorteo_preview:'1'}})})}catch(e){} setTimeout(function(){open('preview')},600); }
    else {
      if(!quiet){ var iv=setInterval(function(){ if(shown){clearInterval(iv);return;} check(); },500); }
      if(window.matchMedia('(hover:hover) and (pointer:fine)').matches){ document.addEventListener('mouseout',function(e){ if(!shown&&!e.relatedTarget&&e.clientY<=0&&(Date.now()-ss.t0)>20000) open('exit_intent'); }); }
    }
    var close=function(){ if(d.open) d.close(); };
    d.addEventListener('close',function(){ if(!submitted){ save({s:'dismissed',t:Date.now()}); track('gift_draw_popup_close',{}); } });
    d.addEventListener('click',function(e){ if(e.target===d){close();return;} var c=e.target.closest&&e.target.closest('[data-asdraw-close]'); if(c) close(); });
    var form=d.querySelector('form'), err=d.querySelector('[data-asdraw-err]'), cta=d.querySelector('[data-asdraw-cta]'), busy=false;
    if(form) form.addEventListener('submit',function(e){
      if(busy) return;
      var email=form.querySelector('input[type=email]'), chk=form.querySelector('input[type=checkbox]');
      track('gift_draw_cta_click',{});
      if(!email.value||!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value)){ e.preventDefault(); err.textContent='Escribe un email válido.'; email.focus(); return; }
      if(!chk.checked){ e.preventDefault(); err.textContent='Marca la casilla para recibir el recordatorio por email.'; chk.focus(); return; }
      // Envío nativo: Shopify añade su verificación anti-bots y vuelve a esta misma página con el resultado.
      var label=cta.textContent; err.textContent=''; busy=true; submitted=true; cta.textContent='Enviando…';
      setTimeout(function(){ busy=false; submitted=false; cta.textContent=label; err.textContent='No hemos podido enviarlo. Inténtalo de nuevo.'; },12000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-final"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if(!('IntersectionObserver' in window)) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els=document.querySelectorAll('.asd-rv'); if(!els.length) return;
    document.documentElement.classList.add('asd-js');
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el);});
    setTimeout(function(){els.forEach(function(el){el.classList.add('is-in');});},4000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-motion"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var cs=document.querySelectorAll('.asmo__c'); if(!cs.length) return;
    if(!('IntersectionObserver' in window)){cs.forEach(function(c){c.classList.add('is-in');});return;}
    var rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io=new IntersectionObserver(function(en){en.forEach(function(e){
      var v=e.target.querySelector('video');
      if(e.isIntersecting){e.target.classList.add('is-in'); if(v&&!rm){v.muted=true;var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});}}
      else{e.target.classList.remove('is-in'); if(v){v.pause();}}
    });},{threshold:.5});
    cs.forEach(function(c){io.observe(c);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
